export function farloUiMobileSlider(element) {
    const carouselElement = document.querySelector('.cards-slider__enable');
    if (!element) return;

    const mediaQuery = window.matchMedia('(max-width: 980px)');
    let flkty = null; // To store Flickity instance

    imagesLoaded(element, () => {
        handleResize();
    });

    // Debounced resize listener
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(handleResize, 150);
    });

    function initializeFlickity() {
        if (flkty) return; // Already initialized
        flkty = new Flickity(element, {
            cellAlign: 'center',
            contain: true,
            pageDots: true,
            prevNextButtons: false,
            wrapAround: true,
            groupCells: false,
            freeScroll: true,
            draggable: true,
            scrollSnap: true,
            adaptiveHeight: false,
            autoPlay: true,
        });

        flkty.on('ready', () => flkty.resize());

        setTimeout(() => flkty.resize(), 100);
    }

    function destroyFlickity() {
        if (!flkty) return; // Nothing to destroy
        flkty.destroy();
        flkty = null;
    }

    // function handleResize() {
    //     if (mediaQuery.matches) {
    initializeFlickity();
    //     } else {
    //         destroyFlickity();
    //     }
    // }
}
